<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.surcharge.edit.formation.surchargeDetails', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name"
                                                   [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                                  [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                        <ng-container formGroupName="modifier">
                            <wbo-single-select-edit-control formControlName="type" (valueChange)="modifierTypeChanged()"
                                                            [(ngModel)]="model.data.modifier.type">
                                <wbo-select-options>
                                    <wbo-select-option [value]="Markup_Type.FIXED_MARKUP" label="wbo.surcharge.edit.option.surchargetype.fixedSurcharge">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="Markup_Type.PERCENT_MARKUP" label="wbo.surcharge.edit.option.surchargetype.percentSurcharge">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </ng-container>
                        <fui-tandem-field>
                            <ng-container formGroupName="modifier">
                                <wbo-numeric-edit-control formControlName="value"
                                                          [decimals]="2" [notation]="getMarkupNotation() | translate"
                                                          [(ngModel)]="model.data.modifier.value"></wbo-numeric-edit-control>
                            </ng-container>
                            <fui-column>
                                <wbo-checkbox-edit-control formControlName="taxApplicable"
                                                           [(ngModel)]="model.data.taxApplicable"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.description">
                        </wbo-textarea-edit-control>
                        <wbo-period-schedule-multi-select-edit-control formControlName="periodSchedules"
                                                                       [multiObjectValueType]="true"
                                                                       [(ngModel)]="model.data.periodSchedules"></wbo-period-schedule-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <ng-container
        *ngIf="(Config.BACKOFFICE_PRICING_MAINTAIN_SURCHARGE_DISCOUNT_INTERACTION_VIA | stringConfig) !== 'discount'">
        <fui-formation-group-template
            *formationGroup="{title: 'wbo.surcharge.edit.formation.discountInteractions', formControlNames: ''}">
            <fui-rows>
                <fui-row>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.discountInteractions" [editable]="true" [removable]="true"
                                       [entityPath]="'discountInteractions'">
                            <wbo-edit-link-column field="discount.name" componentPath="discount"
                                                  [editPath]="'discount'" [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                            <wbo-translated-column field="discount.modifier.displayType" prefix="wbo.pricing.markup-type"></wbo-translated-column>
                            <wbo-numeric-column field="discount.modifier.value"></wbo-numeric-column>
                            <wbo-checkbox-column field="surchargeUndiscountedPrice" [editable]="true"></wbo-checkbox-column>
                            <wbo-edit-grid-add-row [identifierField]="'discountId'" componentPath="discount" #addRow
                                                   [customAddQuickSelect]="true">
                                <wbo-edit-grid-add-row-quick-add (onSelect)="addRow.addRow($event, true)">
                                    <wbo-discount-single-select-edit-control></wbo-discount-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search
                                        [searchPath]="'discount-search'"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity
                                        [editPath]="'discount'"></wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-row>
            </fui-rows>
        </fui-formation-group-template>
    </ng-container>
</wbo-edit-page>
